import { Product } from "@hermes/api-model-product";

export const getGiftSetSize = (product: Product) =>
    product.giftSetAttributes?.slot ?? 0;
